// extracted by mini-css-extract-plugin
export default {"Laws":"Laws_Laws__hxA7d","Content":"Laws_Content__Zb5nt","List":"Laws_List__yHHr3"};